"use client";

import type { DiscoverSelection } from "@/components/discover/filters/selection";
import type { Coords } from "@/types/places";
import type { CustomLocation, MapAreaId } from "@/utils/location";
import { SearchPreviewBar } from "./SearchPreviewBar";

type MobileSearchBarProps = {
  currentArea: MapAreaId;
  currentCustomLocation?: CustomLocation | null;
  coords: Coords;
  selection: DiscoverSelection;
  redirectToHome?: boolean;
};

export function MobileSearchBar({
  currentArea,
  currentCustomLocation,
  coords,
  selection,
  redirectToHome,
}: MobileSearchBarProps) {
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-4 min-w-0 md:hidden">
      <SearchPreviewBar
        currentArea={currentArea}
        currentCustomLocation={currentCustomLocation}
        coords={coords}
        selection={selection}
        redirectToHome={redirectToHome}
      />
    </div>
  );
}
